import React, { FC } from "react";
import { LoadingAnimation } from "../LoadingAnimation/LoadingAnimation";
import classnames from "classnames";

interface WaitlistSubmitButtonProps {
  text: string;
  onClick: () => void;
  requestInProgress: boolean;
  isPrimary?: boolean;
}

export const WaitlistSubmitButton: FC<WaitlistSubmitButtonProps> = (props) => {
  return (
    <div className="mt-auto mb-1">
      <button
        className={classnames(
          "btn",
          "w-100",
          props.isPrimary ? "btn-primary" : "btn-light"
        )}
        onClick={props.onClick}
        disabled={props.requestInProgress}
      >
        {props.requestInProgress ? (
          <LoadingAnimation text={props.text} />
        ) : (
          props.text
        )}
      </button>
    </div>
  );
};
